<div class="container" style="border: 2px solid green; height:1900px; max-width: 1270px;">
    <div class="row" style="height: 100%;">
        <div class="col-md-8 col-12" style="border: 1px solid blue; height: 100%">

        </div>
        <div class="col-md-4 col-12" style="border: 1px solid blue; height: 100%">

        </div>
    </div>
</div>